<template>
	<div class="pt-1">
		<div class="form-desc pt-3">
			{{ t('batchTypesDescText','batchTypesDescText') }}
		</div>
		<div class="table-responsive">
			<div class="row pl-2">
				<b-button class="btn btn-success" @click="openAddModal(t('addBatchTypeModalTitle', 'addBatchTypeModalTitle'), $event.target, 'batchTypeChild')">{{ t('addBatchTypeButton','addBatchTypeButton') }}</b-button>
				<b-button class="btn btn-danger" :disabled="selectedBatchTypes.length == 0" @click="openDeleteModal(selectedBatchTypes ,t('deleteBatchTypeModalTitle', 'deleteBatchTypeModalTitle'), $event.target, 'batchTypeChild')">{{ t('deleteBatchTypesButton','deleteBatchTypesButton') }}</b-button>
			</div>
			<b-table striped hover fixed v-bind:items="getBatchTypes" v-bind:fields="this.table_fields" id="batchTypes-table" :per-page="perPage" :currentPage="currentPage" :filter="filter">
				<template v-slot:cell(checkbox)="data">
					<b-form-checkbox :value="data.item.name" v-model="selectedBatchTypes"></b-form-checkbox>
				</template>
				<template v-slot:cell(edit_info)="data">
					<div class="horizontal-display">
						<span class="ml-2 showhand">
							<fontAwesomeIcon :icon="['fas', 'pen']" size="1x" class="text-primary align-middle"
							@click="openEditModal(t('editBatchTypeModalTitle', 'editBatchTypeModalTitle'), data.item.name, $event.target, 'batchTypeChild', data.item.class, data.item.id, '', '', '', '')"/>
						</span>
						<span class="ml-2 showhand">
							<router-link :to="{ name: 'core_types_info_batch_type', query: { id: data.item.id } }">
								<fontAwesomeIcon :icon="['fas', 'info-circle']" size="1x" class="text-primary align-middle"/>
							</router-link>
						</span>
					</div>
				</template>
				<template v-slot:cell(name)="data">
					{{ data.item.name }}
				</template>				
				<template v-slot:cell(index)="data">
					<span v-if="currentPage == 1">{{ data.index + 1 }}</span>
					<span v-else>{{ data.index + 1 + perPage * (currentPage - 1) }}</span>
				</template>
				<template v-slot:cell(class)="data">
					{{ data.item.class }}
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-lg-2 col-md-4 col-sm-12 mb-2 mb-md-0">
				<b-input-group>
					<b-input-group-prepend>
						<label class="input-group-text">{{ t('recordsPerPageText', 'recordsPerPageText') }}</label>
					</b-input-group-prepend>
					<b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
				</b-input-group>
			</div>
			<div class="col-lg-2 col-md-3 col-sm-12 mb-2 mb-md-0">
				<b-input-group>
					<b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
					<b-input-group-append>
						<b-button :disabled="!filter" @click="filter = ''">{{ t('clearButtonText','clearButtonText') }}</b-button>
					</b-input-group-append>
				</b-input-group>
			</div>
			<div class="col-lg-8 col-md-3 col-sm-12 mb-2 mb-md-0">
        <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="total_rows" :per-page="perPage" aria-controls="translation-table" v-if="total_rows > 0"></b-pagination>
      </div>
		</div>
		<!-- DELETE BATCH TYPES MODAL -->
		<b-modal class="modal-lg" :id="deleteModal.id" :title="deleteModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetDeleteModal('batchTypeChild')">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ deleteModal.title }} ?</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
			</template>
			<template slot="default">
				<div class="row modal-body-log">
					<div v-if="!(deleteModal.length === undefined)" class="col-lg-12 py-2"><span>{{ t('deleteBatchTypeModalQuestion', 'deleteBatchTypeModalQuestion') }} </span> <span class="font-weight-bold" v-for="(name, index) in deleteModal.name" :key="name">{{name}} <span v-if="index+1 < deleteModal.name.length">, </span></span>?</div>
				</div>
			</template>
			<template slot="modal-footer" slot-scope="{ ok, cancel }">
				<b-button variant="danger" @click="deleteBatchTypes(), ok()">Delete</b-button>
				<b-button variant="secondary" @click="cancel()">Cancel</b-button>
			</template>
		</b-modal>
		<!-- ADD BATCH TYPE MODAL -->
		<b-modal class="modal-addBatchType" :id="addModal.id" :title="addModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetAddModal('batchTypeChild')">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ addModal.title }}</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
			</template>
			<template slot="default">
				<div class="row modal-body-log">
					<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
						<b-input-group>
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('batchTypeNameLabelText', 'batchTypeNameLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="batch_type_name" v-model="newBatchType.name"></b-form-input>
						</b-input-group>
						<div class="col-lg-12 py-1">
							<span class="pretext-span tips-font-size">{{ t('batchTypeNameTipText', 'batchTypeNameTipText') }}</span>
						</div>
						<b-input-group>
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('batchTypeClassLabelText', 'batchTypeClassLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="batch_type_class" v-model="newBatchType.class"></b-form-input>
						</b-input-group>
						<div class="col-lg-12 py-1">
							<span class="pretext-span tips-font-size">{{ t('batchTypeClassTipText', 'batchTypeClassTipText') }}</span>
						</div>
					</b-form-group>
				</div>
			</template>
			<template slot="modal-footer" slot-scope="{ ok, cancel }">
				<b-button variant="success" :disabled="newBatchType.name == '' || newBatchType.class == ''" @click="addBatchType(), ok()">Add</b-button>
				<b-button variant="secondary" @click="cancel()">Cancel</b-button>
			</template>
		</b-modal>
		<!-- EDIT BATCH TYPE MODAL -->
		<b-modal class="modal-lg" :id="editModal.id" :title="editModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetEditModal('batchTypeChild')">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ editModal.title }}</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
			</template>
			<template slot="default">
				<div class="row modal-body-log">
					<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
						<b-input-group>
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('batchTypeNameLabelText', 'batchTypeNameLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="batch_type_name" v-model="editModal.name"></b-form-input>
						</b-input-group>
						<div class="col-lg-12 py-1">
							<span class="pretext-span tips-font-size">{{ t('batchTypeNameTipText', 'batchTypeNameTipText') }}</span>
						</div>
						<b-input-group>
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('batchTypeClassLabelText', 'batchTypeClassLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="batch_type_class" v-model="editModal.class"></b-form-input>
						</b-input-group>
						<div class="col-lg-12 py-1">
							<span class="pretext-span tips-font-size">{{ t('batchTypeClassTipText', 'batchTypeClassTipText') }}</span>
						</div>
					</b-form-group>
				</div>
			</template>
			<template slot="modal-footer" slot-scope="{ ok, cancel }">
				<b-button variant="success" :disabled="editModal.name == '' || editModal.class == ''" @click="editBatchType(), ok()">Update</b-button>
				<b-button variant="secondary" @click="cancel()">Cancel</b-button>
			</template>
		</b-modal>		
		<div v-if="modalOpen" class="modal-backdrop show"></div>
		<ResponseInfo v-if="getResponseInfo.responseName == 'coreTypesBatches'" class="mt-3"/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
	name: 'BatchTypes',
	inject: [
		'openEditModal',
		'resetEditModal',
		'resetAddModal',
		'resetDeleteModal',
		'openDeleteModal',
		'openAddModal'
	],	
	data() {
    return {
			table_fields: [
				{key: 'index', label: '#', thStyle: 'width: 40px', tdClass: 'text-center px-2', thClass: 'text-center'},
				{key: 'checkbox', label: '', thStyle: 'width: 20px'},
				{key: 'edit_info', label: '', thStyle: 'width: 80px'},
				{key: 'name', sortable: true, label: 'name', thClass: 'hover-pointer', thStyle: 'width: 300px'},
				{key: 'class', sortable: true, label: 'class', thClass: 'hover-pointer'},
			],
			batchTypes: {},
			selectedBatchTypes: [],
			pageOptions: [10, 20, 50, 100],			
			perPage: 10,
			currentPage: 1,
			filter: null,
			modalOpen: null,
			editedBatchType:{
				name: '',
				class: ''
			},
			newBatchType: {
				name: '',
				class: ''
			},
			deleteModal: {
				length: 0,
				title: '',
				id: 'delete-modal-batchType'
			},
			addModal: {
				title: '',
				id: 'add-modal-batchType'
			},
			editModal: {
				name: '',
				class: '',
				title: '',
				batchId: '',
				id: 'edit-modal-batchType'
			}
    }
	},
	created() {
		this.$store.dispatch('coreTypesStore/getBatchTypesList')
		.then(() => {
			this.batchTypes = this.$store.getters['coreTypesStore/getBatchTypes']
		})
	},
	components: {
		ResponseInfo
	},
	computed: {
		...mapGetters('coreTypesStore' ,['getBatchTypes']),
		...mapGetters(['getResponseInfo']),
		total_rows() {
			return this.$store.getters['coreTypesStore/getBatchTypes'].length
		}
	},
	methods: {
		deleteBatchTypes() {
			this.$store.dispatch('coreTypesStore/deleteBatchTypes', {
				batchSelected: this.selectedBatchTypes
			}).then(() => {
				this.selectedBatchTypes = []
			})
		},	
		addBatchType() {
			this.$store.dispatch('coreTypesStore/addBatchType', {
				batchName: this.newBatchType.name,
				batchClass: this.newBatchType.class
			})
		},
		editBatchType() {
			this.$store.dispatch('coreTypesStore/editBatchtype', {
				batchName: this.editModal.name,
				batchClass: this.editModal.class,
				batchId: this.editModal.batchId
			}).then(() => {
				this.editModal.name = ''
				this.editModal.class = ''
			})
		}
	}
}
</script>

<style scoped>

  .showhand{
    cursor: pointer;
  }

	.tips-font-size{
		font-size: 12px;
	}
	.horizontal-display{
		display: flex;
	}

</style>